import Interieur from "./Interieur";
import TuerFluegel from "./TuerFluegel";
import FullHeightDragable from "./FullHeightDragable";
import { v2, v3 } from "oc-threejs/short3";

export default class Tuer extends FullHeightDragable {
    // DO NOT CHANGE
    className = "Tuer";

    // persistent (UserLayer) ------------------------------------------

    // transient (CompiledLayer) ---------------------------------------

    fluegel: ?TuerFluegel[] = [];
    isClosed = true;

    griffHoehe = 0;
    inputVisible = false;
    side = '';

    frontBox = new THREE.Box3();

    constructor(type, element) {
        super(type, element);
    }

    getElementBox(element) {
        return element.unverdeckt.box;
    }

    get frontSize() {
        return this.frontBox.getSize();
    }

    get hasFronts() {
        return true;
    }

    getFrontOffset() {
        const aufschlagend = this.schrank.options.getFloat('aussenwand_vorsprung') == 0.0;
        return aufschlagend ? this.schrank.options.getFloat('brett_staerke') : 0;
    }

    // beide, links, rechts
    getSide() {
        return this.product.Art.split(':')[0];
    }

    // standard, spiegel, glas
    getMaterial() {
        return this.product.Art.split(':')[1];
    }

    get isShallow() {
        return true;
    }

    getAdditionalRulerBox(dir, showHeight = false) {
        const rulerBoxes = [];
        if (APP.settings.getBool('drag_drop_ux_ruler_show', true)) {
            const worldBox = this.element.schrankBox.clone();
            let doorMaxHeight = worldBox.max.y;
            let doorMinHeight = 0;
            const topRulerBox = worldBox.clone();
            if ((this.schrank.arrangement.type === 'DachschraegeLinks' && this.product.Art.split(':')[0] === 'rechts')
                || (this.schrank.arrangement.type === 'DachschraegeRechts' && this.product.Art.split(':')[0] === 'links')) {
                topRulerBox.min.y = this.schrank.slopings.yOfX(this.localToSchrank(this.box.min).x);
                doorMinHeight = this.schrank.slopings.yOfX(this.localToSchrank(this.box.min).x);
            } else {
                if(this.boden.top) {
                    topRulerBox.min.y = _.clone(this.boden.top.schrankBox).max.y;
                    doorMinHeight = _.clone(this.boden.top.schrankBox).max.y;
                } else {
                    topRulerBox.min.y = _.clone(this.element.box).max.y;
                    doorMinHeight = _.clone(this.element.box).max.y;
                }
                
            }
            topRulerBox.max.y = _.clone(this.element.slopeTop);
            if (topRulerBox.getSize().y > 1.9) {
                rulerBoxes.push(this.getBox3World(topRulerBox));
            }
            doorMaxHeight = topRulerBox.min.y;
            const bottomRulerBox = worldBox.clone();
            bottomRulerBox.min.y = _.clone(this.schrank.schrankboden.schrankBox).max.y;
            bottomRulerBox.max.y = this.boden.bottom ? _.clone(this.boden.bottom.schrankBox).min.y : _.clone(this.boden.top.schrankBox).min.y;
            if (bottomRulerBox.getSize().y > 1.9) {
                rulerBoxes.push(this.getBox3World(bottomRulerBox));
            }
            doorMinHeight = bottomRulerBox.max.y;
            if (showHeight) {
                const heightRulerBox = worldBox.clone();
                heightRulerBox.min.y = doorMinHeight;
                heightRulerBox.max.y = doorMaxHeight;
                if (heightRulerBox.getSize().y > 1.9) {
                    rulerBoxes.push(this.getBox3World(heightRulerBox));
                }
            }
        }
        return rulerBoxes
    }

    getPrice() {
        const brettZuschlag = APP.settings.fixPreis.Bretter;
        const drillteqZuschlagKonstruktionsboden = APP.settings.fixPreis.DrillteqKonstruktionsboden;

        let price = 0.0;

        this.fluegel.forEach( fluegel => {
            price += fluegel.front.getPrice();
        });

        this.element.konstruktionsboeden.forEach(ks => price += ks.getPrice() + brettZuschlag + drillteqZuschlagKonstruktionsboden);

        const scharniere = APP.findProductVariancesMatching("Tuerscharniere");
        const sortedByHeight = _.sortBy(scharniere, "abHöhe");
        const flügelHöhe = this.fluegel[0]?.front?.size.y || 0;
        const sliceIndex = sortedByHeight.findLastIndex(z => z.abHöhe <= flügelHöhe);
        const scharniereMatchingHeight = sortedByHeight.slice(sliceIndex < 0 ? 0 : sliceIndex);
        const product = scharniereMatchingHeight[0];
        if(product) {
            price += product.PreisStandard * this.fluegel.length;
        }

        return Math.round(price);
    }

    canOverlay(other: Interieur) {
        return other === this || !other.hasFronts;
    }

    compileFront() {
        if (!this.schrank) {
            return;
        }
        const lazyTuerfluegel = APP.model.lazyPool(this, 'fluegel', () => new TuerFluegel(this));
        if (this.getSide() == 'beide') {
            const links = lazyTuerfluegel.next();
            links.side = 'links';
            const rechts = lazyTuerfluegel.next();
            rechts.side = 'rechts';
        } else {
            const fluegel = lazyTuerfluegel.next();
            fluegel.side = this.getSide();
        }
        lazyTuerfluegel.cleanup();

        if (this.element && !this.boden.bottom) {
            APP.model.maybeThrowCompileError(this, "Tür ohne Böden!", "Tür ohne Böden!");
        }

        this.fluegel.forEach(f => f.compileFront());
        this.griffHoehe = this.fluegel[0].griff
            ? this.fluegel[0].griff.position.y - this.fluegel[0].front.box.min.y
            : 0;


        this.frontBox.makeEmpty();
        this.fluegel.forEach(f => this.frontBox.union(f.front.box));

    }

    showClosed(close, time) {
        if (close === this.isClosed) return;
        this.isClosed = close;
        this.fluegel.forEach((f, i) => f.showClosed(close, time));
        this.object3d.setChangeable(close);
    }

    changeHeight(height) {
        const schrankBox = this.element.schrankBox.clone();
        const delta = this.frontBox.getSize().y - this.boxLocal.getSize().y;
        height-=delta;
        const y = height;
        const fit = this.element.getInterieurYFitAtPos(this);
        const box = this.boxLocal.clone();
        let positionY = 0;

        if (this.side == 'up') {

            box.max.y = this.frontBox.min.y + height;
            box.min.y = this.frontBox.min.y;
            schrankBox.min.y = this.frontBox.min.y;
            schrankBox.max.y = this.frontBox.min.y + height;
            positionY = this.boden.bottom.schrankBox.max.y + height/2;
        } else {
            box.min.y = this.frontBox.max.y - height;
            box.max.y = this.frontBox.max.y; 
            schrankBox.min.y = fit.maxCollapse - height;
            schrankBox.max.y = fit.maxCollapse;
            positionY = this.boden.top.schrankBox.min.y - height/2;

        }

        const newData = v3(schrankBox.getCenter().x, positionY, schrankBox.getCenter().z)

        this.object3d.position.copy(newData);
        this.position.copy(newData);
        this.size.copy(box.getSize());

        this.object3d.ruler.removeRuler()
        this.object3d.ruler.interieurDragRuler = this.getAdditionalRulerBox('both', true/*this.vsData.dragDir*/);
        this.object3d.ruler.vsUpdate(true, true);

        APP.model.setDirty();

    }

    fromJSON(json) {
        super.fromJSON(json);
        this.isDropped = true;
        return this;
    }

    toJSON() {
        const json = super.toJSON();
        json.frontBox = this.frontBox;
        json.frontSize = this.frontBox.getSize();
        json.griffHoehe = this.griffHoehe;
        json.griffAbstandSeite = this.schrank.options.getFloat('tuer_griff_abstand_horizontal');
        json.griffArtikel = APP.arrangement.griffArtikelnummer;
        // Ausrichtung später vlt dynamisch? // senkrecht / waagerecht
        json.griffAusrichtung = "senkrecht";
        json.eckTuerOhneGriff = this.fluegel.length > 0 ? this.fluegel[0].ecktuerOhneGriff() : false;
        json.className = this.className;
        return json;
    }

    setFromProduct(product) {
        this.product = product;
        this.fluegel = [];
        this.compileFront();
        APP.model.setDirty();
    }

    // die Tür hat einen Dialog, der bei nicht passenden Türen eine passende sucht
    acceptElement(element) {
        if (element.schrank.options.getBool('offenes_eckelement') && (!element.wallLeft || !element.wallRight)) {
            return false;
        }
        if (element.isEckElement && element.verdecktVonElementen.length > 0) {
            return false;
        }
        return super.acceptElement(element) && element.getNumberOfParentElements() === 0;
    }

    canTopBeSlopedInElement(element) {
        const side = this.getSide();
        if (side === 'beide') {
            return false;
        }
        const sl = element.slopeTopLeft;
        const sr = element.slopeTopRight;
        const e = 0.01;
        return (side === 'links' && sl > sr + e) || (side === 'rechts' && sl + e < sr);
    }

    _validate() {
        if (!this.isDropped) {
            return;
        }

        if (this.size.y < this.schrank.options.getFloat('tuer_hoehe')) {
            APP.model.maybeThrowCompileError(this, 'compileError', 'dialogInteriorMinHeight', this.product.Name, this.schrank.options.getFloat('tuer_hoehe'));
        }

        super._validate();
    }

    get flaechenMass() {
        return this.frontBox.getSize();
    }

    iterate(iterator) {
        iterator(this);
        this.fluegel.forEach(x => x.iterate(iterator));
    }

}
